'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowSize = exports.session = exports.locInfo = exports.history = exports.graph2 = exports.form = exports.firebase = exports.errorMessage = exports.db = exports.config = exports.collection = exports.auth = undefined;

var _defaultTo2 = require('lodash/fp/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _capeReduxAuth = require('cape-redux-auth');

Object.defineProperty(exports, 'auth', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_capeReduxAuth).default;
  }
});

var _capeReduxCollection = require('cape-redux-collection');

Object.defineProperty(exports, 'collection', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_capeReduxCollection).default;
  }
});

var _reducer = require('./db/reducer');

Object.defineProperty(exports, 'db', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer).default;
  }
});

var _errMsg = require('./errMsg');

Object.defineProperty(exports, 'errorMessage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_errMsg).default;
  }
});

var _capeFirebase = require('cape-firebase');

Object.defineProperty(exports, 'firebase', {
  enumerable: true,
  get: function get() {
    return _capeFirebase.reducer;
  }
});

var _reduxField = require('redux-field');

Object.defineProperty(exports, 'form', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reduxField).default;
  }
});

var _reduxGraph = require('redux-graph');

Object.defineProperty(exports, 'graph2', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reduxGraph).default;
  }
});

var _reduxHistorySync = require('redux-history-sync');

Object.defineProperty(exports, 'history', {
  enumerable: true,
  get: function get() {
    return _reduxHistorySync.historyReducer;
  }
});

var _locationInfo = require('location-info');

Object.defineProperty(exports, 'locInfo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_locationInfo).default;
  }
});

var _session = require('./session');

Object.defineProperty(exports, 'session', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_session).default;
  }
});

var _reduxWindowsize = require('redux-windowsize');

Object.defineProperty(exports, 'windowSize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reduxWindowsize).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = exports.config = (0, _defaultTo3.default)({});


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-reducer/lib/reducer.js
// module id = 859
// module chunks = 0